export default defineNuxtRouteMiddleware(() => {
  // Проверяем существование window и navigator перед использованием
  const isTelegramWebApp: boolean = typeof window !== 'undefined'
    && typeof navigator !== 'undefined'
    && (/TelegramBot|WebApp/i.test(navigator.userAgent)
      || typeof window.TelegramWebviewProxy !== 'undefined'
      || !!window.Telegram?.WebApp);

  // Создаем глобальное состояние
  const telegramState = useState<boolean>('isTelegramWebApp', () => isTelegramWebApp);

  // Устанавливаем значение
  telegramState.value = isTelegramWebApp;
});
